




























































































import { Component, Vue } from 'vue-property-decorator'
import ErrorFormResponse from '../../modules/class/ErrorFormResponse'
import Download from '../../components/Membership/Download/Download.vue'
import AuthAreaLink from '../../components/Membership/AuthAreaLink.vue'
import GetParameter from '../../modules/util/GetParameter'

@Component({
  components: {
    Download,
    AuthAreaLink
  }
})
export default class SpecialAccess extends Vue {
  // --------------------------------------------------------------------------------------------------------------------
  // Props

  // -------------------------------------------------------------------------------------------------------------------
  // data
  private getParam = GetParameter.currentGetParameter()
  private targetUrl: URL = new URL(window.location.origin)
  private resultError: ErrorFormResponse = {}
  private haserror = false

  // -------------------------------------------------------------------------------------------------------------------
  // hocks

  private created() {
    // エラーメッセージの初期化
    this.clearError()

    // fileパラメータからURLを取得
    const setUrl = new URL(
      window.location.origin + this.getParam.get('file').replace(/\?.*$/, '')
    )

    // 現在のURLにfromが含まれている場合、setUrlにfromパラメーターを設定
    const fromParam = this.getParam.get('from').replace(/\?.*$/, '')
    if (fromParam.length > 0) {
      setUrl.searchParams.set('from', fromParam)
    }

    // 現在のURLにtokenが含まれている場合、setUrlにtoneパラメーターを設定
    const tokenParam = this.getParam.get('token')
    if (tokenParam.length > 0) {
      setUrl.searchParams.set('token', tokenParam)
    }

    setUrl.hash = this.getParam.getHash()
    this.targetUrl = setUrl
  }

  private mounted() {
    // リダイレクト
    setTimeout(() => {
      this.redirect()
    }, 500)
  }

  // -------------------------------------------------------------------------------------------------------------------
  // Computed

  get download(): Download {
    return this.$refs.download as Download
  }

  get auth(): AuthAreaLink {
    return this.$refs.authAreaLink as AuthAreaLink
  }

  /**
   * パラメータが正しく指定されているかチェック
   */
  get hasParam(): boolean {
    return this.getParam.hasParamKey('file')
  }

  /**
   * パラメータのURLがPIMとして正しいか
   */
  get isDocumentUrl(): boolean {
    const reDoc = /\/sites\/.+\/files\/pim\/pim_document_file\/.*.pdf/i
    return reDoc.test(this.targetUrl.pathname)
  }

  /**
   * パラメータのURLがページとして正しいか
   */
  get isLinkUrl(): boolean {
    const reDoc = /^\/.*.(html|pdf)/i
    return reDoc.test(this.targetUrl.pathname)
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  /**
   * 各リンクに応じたリダイレクト処理を行う
   */
  private redirect() {
    if (this.isDocumentUrl) {
      // 不足項目確認画面にて不足項目をSaveした後、ダウンロード処理を実行させるためにイベントリスナーを追加する
      document.addEventListener(
        'complete-verify-login',
        (e) => {
          this.download.start(this.targetUrl)
        },
        false
      )
    } else if (this.isLinkUrl) {
      this.auth.checkSignin(window.location.origin + this.targetUrl.pathname)
    }
  }

  /**
   * Accessページに表示されたURLをクリックしたときに実行される処理
   */
  private startDownload() {
    this.download.start(this.targetUrl)
  }

  /**
   * download url clickにて発生したエラーを初期化する
   */
  private clearError() {
    this.resultError = {}
    this.haserror = false
  }

  /**
   * download url clickにて発生したエラーをDownladLinkコンポーネントから受け取る
   */
  private setError(error: ErrorFormResponse) {
    this.resultError = error
    this.haserror = true
  }
}
